import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IActivityTimeAvailability } from 'app/shared/model/activity-time-availability.model';
import { getEntities as getActivityTimeAvailabilities } from 'app/entities/activity-time-availability/activity-time-availability.reducer';
import { IBooking } from 'app/shared/model/booking.model';
import { getEntities as getBookings } from 'app/entities/booking/booking.reducer';
import { IBookingTime } from 'app/shared/model/booking-time.model';
import { getEntity, updateEntity, createEntity, reset } from './booking-time.reducer';

export const BookingTimeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const activityTimeAvailabilities = useAppSelector(state => state.activityTimeAvailability.entities);
  const bookings = useAppSelector(state => state.booking.entities);
  const bookingTimeEntity = useAppSelector(state => state.bookingTime.entity);
  const loading = useAppSelector(state => state.bookingTime.loading);
  const updating = useAppSelector(state => state.bookingTime.updating);
  const updateSuccess = useAppSelector(state => state.bookingTime.updateSuccess);

  const handleClose = () => {
    navigate('/booking-time' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getActivityTimeAvailabilities({}));
    dispatch(getBookings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.bookedTime = convertDateTimeToServer(values.bookedTime);

    const entity = {
      ...bookingTimeEntity,
      ...values,
      activityTimeAvailability: activityTimeAvailabilities.find(it => it.id.toString() === values.activityTimeAvailability.toString()),
      booking: bookings.find(it => it.id.toString() === values.booking.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          bookedTime: displayDefaultDateTime(),
        }
      : {
          ...bookingTimeEntity,
          bookedTime: convertDateTimeFromServer(bookingTimeEntity.bookedTime),
          activityTimeAvailability: bookingTimeEntity?.activityTimeAvailability?.id,
          booking: bookingTimeEntity?.booking?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.bookingTime.home.createOrEditLabel" data-cy="BookingTimeCreateUpdateHeading">
            <Translate contentKey="activitiesApp.bookingTime.home.createOrEditLabel">Create or edit a BookingTime</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="booking-time-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.bookingTime.bookedTime')}
                id="booking-time-bookedTime"
                name="bookedTime"
                data-cy="bookedTime"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="booking-time-activityTimeAvailability"
                name="activityTimeAvailability"
                data-cy="activityTimeAvailability"
                label={translate('activitiesApp.bookingTime.activityTimeAvailability')}
                type="select"
              >
                <option value="" key="0" />
                {activityTimeAvailabilities
                  ? activityTimeAvailabilities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.fromDate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="booking-time-booking"
                name="booking"
                data-cy="booking"
                label={translate('activitiesApp.bookingTime.booking')}
                type="select"
              >
                <option value="" key="0" />
                {bookings
                  ? bookings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/booking-time" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BookingTimeUpdate;
